import { all, put, fork, takeEvery, select } from 'redux-saga/effects';
import actions from './actions';
import { get, post } from '@iso/lib/helpers/resApiRequestor';
import { KEYS } from '@iso/containers/constants';
import moment from 'moment';

export function* fetchAllMonitoringMenuData() {
  yield takeEvery('FETCH_MONITORING_MENU_DATA', function* () {
    try {
      yield put({
        type: actions.FETCHING_MONITORING_MENU_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield fetchAllMonitoringTypeMenuAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MONITORING_MENU_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_MONITORING_MENU_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MONITORING_MENU_DATA_FAILED,
        loading: false
      });
    }
  });
}
export function* filterReportTransactionsData() {
  yield takeEvery('FILTER_REPORT_TRANSACTIONS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FILTERING_REPORT_TRANSACTIONS,
        loading: true
      });
      const state = yield select();
      const reportType = state.Monitoring.reportType;

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield filterReportTransactionsAPI(
        {
          ...payload,
          year: moment(payload.trx_date.to).format('YYYY'),
          month: moment(payload.trx_date.to).format('MMMM')
        },
        reportType,
        roleHeaderAuth
      );

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FILTER_REPORT_TRANSACTIONS_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null,
          filter: payload,
          merchantPagination: result ? result.data.merchant_pagination : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FILTER_REPORT_TRANSACTIONS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FILTER_REPORT_TRANSACTIONS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FILTER_REPORT_TRANSACTIONS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* downloadReportTransactionsData() {
  yield takeEvery('DOWNLOAD_REPORT_TRANSACTIONS', function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_REPORT_TRANSACTIONS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadReportTransactionsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_REPORT_TRANSACTIONS_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_REPORT_TRANSACTIONS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_REPORT_TRANSACTIONS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_REPORT_TRANSACTIONS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
function fetchAllMonitoringTypeMenuAPI(roleAuth) {
  return get(`get-all/monitoring-type`, null, null, null, null, roleAuth);
}
function filterReportTransactionsAPI(data, reportType, roleAuth) {
  if (reportType === KEYS.PROJECTION_STATUS_REPORT) {
    return post(`get/monitoring/projection-status`, data, null, null, roleAuth);
  } else if (reportType === KEYS.AO_PERFORMANCE_REPORT) {
    return post(`get/monitoring/ao-performance`, data, null, null, roleAuth);
  } else {
    return post(`get/monitoring/time-series`, data, null, null, roleAuth);
  }
}
function downloadReportTransactionsAPI(data, roleAuth) {
  return post(`download/report-transactions`, data, null, null, roleAuth);
}

function* getRoleHeader() {
  const state = yield select();
  const identity = state.Auth.identity;
  const currentPage = state.App.currentPage;
  const currentAction = state.App.currentAction;
  if (currentAction) {
    return `${identity.role_id}:${currentPage.id}:${currentAction.id}`;
  } else {
    return `${identity.role_id}:${currentPage.id}`;
  }
}
export default function* rootSaga() {
  yield all([
    fork(fetchAllMonitoringMenuData),
    fork(filterReportTransactionsData),
    fork(downloadReportTransactionsData)
  ]);
}
